export default {"src":"/_next/static/image/public/images/flags/flag_298.c6e4a81f1fd381c53bee2b421e3977a1.svg","height":16,"width":24};